<h2 mat-dialog-title>Notes</h2>
<mat-dialog-content>
    <div class="notes-content">
        @if (data.appName) {
<p class="app-name"><strong>Application:</strong> {{ data.appName }}</p>
}
        <div class="notes-text">
            {{ data.notes || 'No notes available' }}
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="btn" (click)="onClose()">Close</button>
</mat-dialog-actions>